import {ReactNode} from 'react';
import * as css from './SubMetrics.css';

export type TSubMetric = { label: string, value: ReactNode };
export const SubMetrics = ({items}: { items: TSubMetric[] }) => (
    <css.subMetrics>
        {items.map(item => (
            <css.subMetric key={item.label}>
                <css.subLabel>{item.label}</css.subLabel>
                <css.subValue>{item.value}</css.subValue>
            </css.subMetric>
        ))}
    </css.subMetrics>
);
